/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * slider-fade-normail.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Imprt swiper.
 */
import Swiper from "swiper/bundle";

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Setting - Fade Slider - デフォルト
 */
function fadeSlider() {
	const option = {
		loop: true,
		slidesPerView: "auto",
		effect: "fade",
		noSwiping: "true",
		noSwipingClass: "no-swipe",
		preventClicks: true,
		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
		},
		speed: 3000,
		pagination: {
			el: ".swiper-pagination",
			type: "fraction",
			renderFraction: function (currentClass, totalClass) {
				return '<span class="customPagenation"><span class="customPagenationArrows"></span>0<span class="' + currentClass + '"></span> / 0<span class="' + totalClass + '"></span></span>';
			},
		},
	};

	/**
	 * Action - Fade Slider - デフォルト
	 */
	const sliderFadeNormal = new Swiper(".slider-fade", option);
	// console.log(sliderFadeNormal);
}

export { fadeSlider };
